import { loadStripe } from "@stripe/stripe-js";

const stripePublicApiKey = process.env.STRIPE_PUBLIC_KEY!;
const stripePromise = loadStripe(stripePublicApiKey).catch(() => undefined);

export default stripePromise;
